export class CityStateModel {
    stateCode: string = "";
    cityName: string = "";
    zipCode: string = "";
}

export class PaymentDeiails {
    statusCode: number;
    message: number;
    data: Data = new Data();
}
export class practiceDetails{
    practiceName : string;
    practiceAddress: string;
    practicePhone: string;
    practiceEmail : string;
                
}
export class cardInfo {
  credit_card_id: any;
  credit_card_name: any;
  token_number: any;
  expiration_month: any;
  expiration_year: any;
  card_type: any;
}
export class Data {
    amT_DUE:string = '0.00';
    currentDayAmount: string;
    totalAmount: string;
    prI_SEC_OTH_TYPE: string;
    id: string;
    inspayeR_DESCRIPTION: string;
    visit_Date: string;
    visit_Reasons: string;
}

export class CreditCardEncriptionModel {
    plainText: string
}


